'use client';

import { c as _c } from "react/compiler-runtime";
import { PhoneInputValidationIndicator } from './validation-indicator';
import { usePhoneInput } from './context';
export function PhoneInputAction() {
  const $ = _c(1);
  const {
    state
  } = usePhoneInput();
  if (state.validationMessage) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <PhoneInputValidationIndicator />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  return null;
}